import "firebase/firestore";
import api from "../../util/api";
import {
  tDeclineOrderBody,
  tEditCommentOrderBody,
  tEditProductOrderBody,
  tEditShippingOrderBody,
} from "tmt_api/src/types/types.validator";
import { tReduxAction } from "../types";
import { handleErrorEvents } from "../errorHandler/actions";
import { getApiError } from "src/util/apiNew";
import { openModalAsync } from "../modals/actions";
import { AlertModal, tAlertModalProps } from "src/components/Modals/AlertModal";
import { openUrlInNewTab } from "src/util/linking";

type tOrderParams = { orderStatus?: string; start?: string; end?: string };

export const updateProductOrders = (myOrderId: string, myOrderBody: tEditProductOrderBody): tReduxAction => {
  return (dispatch) => {
    return api
      .put({ endpoint: `/orders/${myOrderId}/update`, body: myOrderBody })
      .then(() => {
        dispatch({ type: "RIBBON", message: "Successfully edited order" });
      })
      .catch((er) => {
        dispatch({ type: "RIBBON", message: new Error("If you cannot fulfill the order, please decline it.") });
        throw er;
      });
  };
};
export const updateOrder = (orderId: string, body: tEditCommentOrderBody): tReduxAction => {
  return async (dispatch) => {
    try {
      await api.put({ endpoint: `/orders/${orderId}/update`, body });
      dispatch({ type: "RIBBON", message: "Successfully edited order" });
    } catch (error) {
      const apiError = getApiError(error);
      if (apiError.code === "balance.unexpected") {
        dispatch(
          openModalAsync<tAlertModalProps>(AlertModal, {
            title: "PAYMENT METHOD",
            description:
              "Unfortunately, the payment method this Retailer used at checkout is not going through. Please contact The Main Tab and/or the Retailer to help with this matter.",
          }),
        );
        return;
      }

      if (apiError.code === "tmt.product.oos") {
        dispatch(
          openModalAsync<tAlertModalProps>(AlertModal, { title: "INVENTORY ALERT", description: apiError.message }),
        );
        return;
      }

      dispatch({ type: "RIBBON", message: new Error("Could not edit order") });
    }
  };
};

export const addShipping = (myOrderId: string, myOrderBody: tEditShippingOrderBody): tReduxAction => {
  return async (dispatch) => {
    try {
      await api.put({ endpoint: `/orders/${myOrderId}/update`, body: myOrderBody });
      dispatch({ type: "RIBBON", message: "Successfully edited order" });
    } catch (error) {
      const apiError = getApiError(error);
      if (apiError.code === "balance.unexpected") {
        dispatch(
          openModalAsync<tAlertModalProps>(AlertModal, {
            title: "PAYMENT METHOD",
            description:
              "Unfortunately, the payment method this Retailer used at checkout is not going through. Please contact The Main Tab and/or the Retailer to help with this matter.",
          }),
        );
        return;
      }

      if (apiError.code === "tmt.product.oos") {
        dispatch(
          openModalAsync<tAlertModalProps>(AlertModal, { title: "INVENTORY ALERT", description: apiError.message }),
        );
        return;
      }

      dispatch({ type: "RIBBON", message: new Error("Could not edit order") });
    }
  };
};

export const declineOrder = (myOrderId: string, myOrderBody: tDeclineOrderBody): tReduxAction => {
  return (dispatch) => {
    return api
      .put({ endpoint: `/orders/${myOrderId}/decline`, body: myOrderBody })
      .then(() => {
        dispatch({ type: "RIBBON", message: "Order has been declined" });
      })
      .catch(() => {
        dispatch({ type: "RIBBON", message: new Error("Failed to decline order") });
      });
  };
};

export const exportOrders =
  (myOrderBody: tOrderParams): tReduxAction =>
  (dispatch) => {
    api
      .post<{ downloadURL: string }>({ endpoint: "/report/orders", body: myOrderBody })
      .then(({ data: { downloadURL } }) => {
        if (downloadURL) openUrlInNewTab(downloadURL);
        dispatch(handleErrorEvents(`Successfully Exported Orders!`, "success"));
      })
      .catch((e: Error) => {
        dispatch(handleErrorEvents(`Error! ${e?.message} | ${e?.stack}`, "error", e));
      });
  };
